import { mockApiDocumentationLinkQueryQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockApiDocumentationLinkQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          apiDocumentationLink: 'https://stag-api.sumologic.net/docs/sec/',
        },
      });
    }
  ),
];
